import { Button, Group, useMantineColorScheme } from '@mantine/core';
import classes from './ColorSchemeToggle.module.scss';

export function ColorSchemeToggle() {
  const { setColorScheme } = useMantineColorScheme();

  return (
    <Group justify="end" mt="sm" mr="sm" className={classes.colorScheme}>
      <Button onClick={() => setColorScheme('light')}>Light</Button>
      <Button onClick={() => setColorScheme('dark')}>Dark</Button>
    </Group>
  );
}
